import React from "react";
import { Link } from "react-router-dom";

/**
 * Trial / Lifetime status banner shown at the top of the Dashboard.
 * Pure presentational — receives the trial object from the parent.
 */
export default function TrialBanner({ trial }) {
  if (!trial) return null;

  if (trial.status === "lifetime") {
    return (
      <div className="card-glass p-5 mb-8 border border-[#A3E635]/30" data-testid="lifetime-banner">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 rounded-full bg-[#A3E635]/20 flex items-center justify-center">
            <svg className="w-5 h-5 text-[#A3E635]" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
              <path d="M5 13l4 4L19 7" />
            </svg>
          </div>
          <div>
            <h3 className="text-[#A3E635] font-semibold">Lifetime License Active</h3>
            <p className="text-[#E8E4DC] text-sm">All premium features unlocked forever. Thank you for your support!</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div
      className={`card-glass p-5 mb-8 border ${trial.expired ? "border-red-500/40" : "border-[#A3E635]/30"}`}
      data-testid="trial-banner"
    >
      <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
        <div>
          <h3 className={`font-semibold text-lg ${trial.expired ? "text-red-400" : "text-white"}`}>
            {trial.expired ? "Your trial has expired" : "72-Hour Free Trial"}
          </h3>
          {!trial.expired ? (
            <p className="text-[#E8E4DC] text-sm mt-1">
              <span className="text-[#A3E635] font-bold">{trial.hours_remaining}</span> hours remaining —
              all premium features are unlocked
            </p>
          ) : (
            <p className="text-[#E8E4DC] text-sm mt-1">
              Upgrade to lifetime access to continue using premium features
            </p>
          )}
        </div>
        <Link
          to="/pricing"
          className="bg-[#A3E635] text-black px-6 py-2 rounded-full font-bold text-sm hover:bg-[#8CD025] transition-all whitespace-nowrap"
          data-testid="trial-upgrade-btn"
        >
          {trial.expired ? "Upgrade Now — $39" : "Get Lifetime Access — $39"}
        </Link>
      </div>
      {!trial.expired && (
        <div className="mt-3">
          <div className="w-full bg-white/10 rounded-full h-2">
            <div
              className="bg-[#A3E635] h-2 rounded-full transition-all duration-500"
              style={{ width: `${Math.max(0, (trial.hours_remaining / 72) * 100)}%` }}
            ></div>
          </div>
        </div>
      )}
    </div>
  );
}
